export const initialState = {
    filterInfo: {
        searchText: '',
        documentType: 0,
        take: 10,
        skip: 0,
    },
};

export const mapImagePathIndexMeta = (item: any, meta: any, subIndex: number) => ({
    id: `${subIndex}`,
    img: item.fullName || '-',
    productName: item.productName || '-',
    specialCode: item.specialCode || '-',
    size: item.size || '-',
    colorCode: item.colorCode || '-',
    seasonCode: item.seasonCode || '-',
    merchAgeGroup: item.merchAgeGroup || '-',
    currentStatus: item.currentStatus || '-',
    line: item.line || '-',
    barcode: item.barcode || '-',
    imagePathIndexMetas: {
        id: subIndex,
        barcode: meta.barcode,
        uri: meta.uri,
    },
});

export const parseImageSearchResponseData = (data: any[]) => {
    return data
        .filter((item: any) => item.imagePathIndexMetas && item.imagePathIndexMetas.length > 0)
        .flatMap((item: any) =>
            item.imagePathIndexMetas.map((meta: any, subIndex: number) => mapImagePathIndexMeta(item, meta, subIndex))
        );
};

export const formatNotFoundRecords = (records: string[]) =>
    records.map((item: string) => `${item.slice(0, item.length - 3)} ${item.slice(-3)}`);
